/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {GetFutureTeamMemberScheduleSummaryRequest} from '@cash-web/protos/squareup/timecards/scheduling/service.pb'
import {GetFutureTeamMemberScheduleSummaryResponse} from '@cash-web/protos/squareup/timecards/scheduling/service.pb'


export const getFutureTeamMemberScheduleSummary = (request: GetFutureTeamMemberScheduleSummaryRequest, options?: CashRequestOptions) => post<GetFutureTeamMemberScheduleSummaryRequest, GetFutureTeamMemberScheduleSummaryResponse>("/2.0/cash/get-future-team-member-schedule-summary", request, {...options, rejectOnError: true })